"use strict";

module.exports = require("./is-implemented")() ? Math.sign : require("./shim");



//////////////////
// WEBPACK FOOTER
// ./node_modules/es5-ext/math/sign/index.js
// module id = 186
// module chunks = 0